import React, { Component } from 'react';
import { bool, string, object, func, number } from 'prop-types';
import classnames from 'classnames';

import YouTubePlayer from 'react-player/lib/players/YouTube';
import FilePlayer from 'react-player/lib/players/FilePlayer';

import styles from './MediaPlayer.css';

class MediaPlayer extends Component {
  static propTypes = {
    className: string,
    height: string,
    imageUrl: string,
    onClick: func,
    onEnded: func,
    onPlay: func,
    options: object,
    playing: bool,
    srcUrl: string,
    thumbnail: string,
    volume: number,
    width: string,
    youtubeId: string
  }

  static defaultProps = {
    height: '100%',
    width: '100%',
    volume: 1,
    options: {
      youtube: {
        playerVars: {
          showInfo: 0,
          rel: 0,
          controls: 0,
          autoplay: 0,
          modestbranding: 0,
          fs: 0
        }
      }
    }
  }

  renderYoutubePlayer = () => {
    const { youtubeId, volume, playing, options, onPlay, onEnded, width, height } = this.props;
    const url = `https://www.youtube.com/watch?v=${youtubeId}`;

    return (
      <YouTubePlayer
        ref={this.playerRef}
        url={url}
        volume={volume}
        playing={playing}
        options={options}
        onPlay={onPlay}
        onEnded={onEnded}
        width={width}
        height={height}
      />
    );
  }

  renderFilePlayer = () => {
    const { srcUrl, volume, playing, options, onPlay, onEnded, width, height } = this.props;

    return (
      <FilePlayer
        ref={this.playerRef}
        url={srcUrl}
        volume={volume}
        playing={playing}
        options={options}
        onPlay={onPlay}
        onEnded={onEnded}
        width={width}
        height={height}
      />
    );
  }

  renderImageBackground = () => {
    const { imageUrl } = this.props;

    return <div className={styles.bgImg} style={{ backgroundImage: `url('${imageUrl}')` }} />;
  }

  render () {
    const { className, youtubeId, srcUrl, imageUrl, thumbnail, onClick, playing } = this.props;

    return (
      <div
        className={classnames(styles.mediaWrapper, className)}
        style={imageUrl && { backgroundImage: `url('${imageUrl}')` }}
        onClick={onClick}
      >
        {
          (thumbnail && !playing) &&
            <div className={styles.thumbnail} style={{ backgroundImage: `url('${thumbnail}')` }} />
        }
        {youtubeId && this.renderYoutubePlayer()}
        {srcUrl && this.renderFilePlayer()}
      </div>
    );
  }
}

export default MediaPlayer;


// WEBPACK FOOTER //
// ./src/uis/common/MediaPlayer/MediaPlayer.js